import * as React from 'react';

import { Icons } from '.';
import API from 'src/services/api';

interface IQRProps extends React.HTMLProps<HTMLElement> {
  url: string;
}
interface IQRState {
  code: string;
  error: boolean;
}

class QR extends React.Component<IQRProps, IQRState> {
  state: IQRState = {
    code: '',
    error: false,
  };

  async componentDidMount() {
    const { url } = this.props;
    if (url) {
      try {
        const code = await API.LINK.getQR(url);
        this.setState({ code });
      } catch (err) {
        this.setState({ error: true });
      }
    }
  }

  render() {
    const { className } = this.props;
    const { code, error } = this.state;
    return (
      <div
        className={`relative leading-none inline-block align-middle group py-1 px-1 border border-transparent text-right rounded ${
          code && !error ? 'hover:bg-white hover:border-grey-dark' : ''
        } ${!code && !error ? 'loader' : ''} ${error ? 'text-red' : ''} ${
          className || ''
        }`}
      >
        <Icons.QR className={!code ? 'opacity-50' : ''} />
        {code && (
          <div className="tooltip tooltip--bottom tooltip--right absolute z-30 hidden group-hover:block w-32 bg-white shadow-md border border-grey-dark py-3 px-3">
            <img src={code} alt="QR code" className="align-bottom w-full" />
          </div>
        )}
      </div>
    );
  }
}

export default QR;



// WEBPACK FOOTER //
// ./src/components/QR.tsx